<template>
  <div class="h-full flex flex-col">
    <!-- Tabs container -->
    <div class="flex w-full gap-1">
      <div
        v-for="(tab, index) in tabs"
        :key="index"
        @click="selectTab(tab)"
        :class="[
          'grow py-2 px-3 cursor-pointer text-ellipsis text-center border rounded-tl-lg rounded-tr-lg transition-all',
          tab.isActive ? 'font-bold border-b-0 bg-slate-500 text-white shadow-lg' : 'border-b bg-slate-400 text-gray-200 hover:bg-slate-450'
        ]"
      >
        {{ tab.name }}
      </div>
    </div>

    <!-- Content of the active tab -->
    <div class="flex-1 p-4 border border-t-0 rounded-bl-lg rounded-br-lg bg-slate-500 overflow-auto">
      <slot></slot>
    </div>
  </div>
</template>

<script setup>
import { reactive, ref, provide, onMounted } from 'vue';

// Reactive array to store tabs
const tabs = reactive([]);

// Ref to track the name of the active tab
// const activeTabName = ref(null);

// Function to register a tab
const registerTab = (tab) => {
  tabs.push(tab);
  if (tab.selected) {
    selectTab(tab);
  }
};

// Function to select a tab
const selectTab = (selectedTab) => {
  // console.log(selectedTab);
  tabs.forEach((tab) => {
    tab.setActive(tab.name === selectedTab.name);
    tab.isActive = tab.name === selectedTab.name;
  });
  // activeTabName.value = selectedTab; // Update the active tab name
};

// Provide the functions and active tab name to child components
provide('registerTab', registerTab);
provide('selectTab', selectTab);
// provide('activeTabName', activeTabName);

// Automatically select the first tab if none is selected by default
onMounted(() => {
  if (!tabs.some((tab) => tab.isActive)) {
    selectTab(tabs[0]);
  }
});
</script>

<style scoped>
/* You can use Tailwind classes, so no additional scoped styles are needed here */
</style>
